import React from 'react';
import { THEMES } from '@americanexpress/consumer-travel-base';

const { THEME_WHITE } = THEMES;
const themeContext = React.createContext(THEME_WHITE);

export default themeContext;
